// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type AanvragenDomainEntitiesMuterenMutatieActie =
  (typeof AanvragenDomainEntitiesMuterenMutatieActie)[keyof typeof AanvragenDomainEntitiesMuterenMutatieActie];

export const AanvragenDomainEntitiesMuterenMutatieActie = {
  Geen: 'Geen',
  Muteren: 'Muteren',
  MuterenIngangsdatum: 'MuterenIngangsdatum',
  Royeren: 'Royeren',
} as const;
